import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { deleteCookie, getCookie } from '../utils/helper';

const backendURL = import.meta.env.VITE_APP_BASE_URL || '';

const apiClient = axios.create({
  baseURL: backendURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = getCookie('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    if (error.response?.status === 400 || error.response?.status === 401 || error.response?.status === 500) {
      const responseData = error.response.data as any;
      if (responseData?.error === 'Authorization Failed' || responseData?.details === 'Signature has expired') {
        deleteCookie('accessToken');
        const { setIsTokenExpire } = await import('../features/auth/authSlice');
        const { store } = await import('../state/store');
        store.dispatch(setIsTokenExpire(true));
      }
    }
    return Promise.reject(error);
  },
);

export const fetchData = async <T>(url: string, payload: any, config?: AxiosRequestConfig): Promise<T> => {
  const response = await apiClient.post<T>(url, payload, config);
  return response.data;
};

export const fetchGetData = async <T>(url: string, config?: AxiosRequestConfig): Promise<T> => {
  const response = await apiClient.get<T>(url, config);
  return response.data;
};

export default apiClient;
